interface BookingStepIndicatorProps {
  currentStep: number;
  steps: string[];
}

export default function BookingStepIndicator({ currentStep, steps }: BookingStepIndicatorProps) {
  return (
    <div className="w-full py-8">
      <div className="flex items-center justify-between max-w-4xl mx-auto px-4">
        {steps.map((step, index) => (
          <div key={index} className="flex items-center flex-1">
            <div className="flex flex-col items-center flex-1">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all duration-300 ${
                  index < currentStep
                    ? 'bg-[var(--color-success)] text-white'
                    : index === currentStep
                    ? 'bg-[var(--color-accent)] text-white'
                    : 'bg-[var(--color-muted)] text-[var(--color-muted-foreground)]'
                }`}
              >
                {index < currentStep ? '✓' : index + 1}
              </div>
              <span
                className={`mt-2 text-xs font-medium text-center ${
                  index <= currentStep
                    ? 'text-[var(--color-primary)]'
                    : 'text-[var(--color-muted-foreground)]'
                }`}
              >
                {step}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`h-0.5 flex-1 mx-2 transition-all duration-300 ${
                  index < currentStep
                    ? 'bg-[var(--color-success)]'
                    : 'bg-[var(--color-border)]'
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}